import { gql } from "@apollo/client";

export const assetsFragment = gql`
    fragment Assets on MyLensesGetAssetsResponse {
        total
        items {
            id
            lastUpdated
            status
            name
            type
            rejections {
                message
                reason
            }
            adHocSearchString
            organization {
                id
                name
            }
            previewsCollection {
                items {
                    fileName
                    url
                }
            }
        }
    }
`;
